var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"couple"},[(_vm.title)?_c('dt',{ref:"title",class:{'auto-width': _vm.autoWidth }},[_c('span',[_vm._v(_vm._s(_vm.title)),(_vm.required)?_c('i',{staticClass:"required"}):_vm._e()])]):_vm._e(),_vm._v(" "),_c('dd',{ref:"content",class:_vm.classes},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ee76a8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/couple/couple.vue
// module id = hPUQ
// module chunks = 29